import { API_BASE_URL } from '@config'
import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from './baseQuery'

// initialize an empty api service that we'll inject endpoints into later as needed
const api = createApi({
  baseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'Event',
    'Modules',
    'Classroom',
    'Discord',
    'Discussion',
    'Documents',
    'Geoguesser',
    'Hyperbeam',
    'Languages',
    'Localization',
    'Musicbox',
    'Neopayment',
    'Notes',
    'Notification',
    'Payment',
    'Pictionary',
    'Rating',
    'Revision',
    'Storage',
    'Teacher',
    'Transcript',
    'Translate',
    'Weblinks',
    'Whiteboard',
  ],
})

export { api as baseApi }
